import React from 'react';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';

const faqs = [
  {
    question: 'How fast can ClipThis turn a long recording into clips?',
    answer: 'Most 60-minute recordings finish analysis in under 6 minutes. Priority plans run 2x faster thanks to dedicated GPU queues.',
  },
  {
    question: 'Do I keep full ownership of exported clips?',
    answer: 'Yes. You retain all rights to your content. ClipThis only stores temporary processing files so you can re-export later.',
  },
  {
    question: 'Can I customize caption styles?',
    answer: 'Absolutely. Pick from 30+ presets or create a custom template with fonts, brand colors, and motion. Save it as a team default.',
  },
  {
    question: 'Does ClipThis support team collaboration?',
    answer: 'Pro and Lifetime plans include guest review links, comments, and shared libraries so editors, managers, and clients stay aligned.',
  },
  {
    question: 'How does pricing work?',
    answer: 'You can start free with limited exports. Pro subscriptions unlock higher limits, faster processing, and advanced analytics.',
  },
];

const FAQ: React.FC = () => {
  return (
    <>
      <SEOHead
        title="ClipThis FAQ"
        description="Answers to the most common questions about ClipThis AI video clipping, pricing, exporting, and collaboration."
        url="/faq"
        schemaData={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }}
      />
      <BreadcrumbSchema
        items={[
          { name: 'FAQ', path: '/faq' },
        ]}
      />
      <div className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
        <section className="relative z-10 max-w-4xl mx-auto px-6 py-16 animate-fade-up">
          <p className="text-red-600 uppercase tracking-[0.3em] text-xs mb-3">FAQ</p>
          <h1 className="text-4xl font-display font-bold text-gray-900 mb-6">Quick answers</h1>
          <div className="space-y-6">
            {faqs.map((faq) => (
              <div key={faq.question} className="p-6 rounded-2xl border border-gray-200 bg-gray-50">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">{faq.question}</h2>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default FAQ;

